const ExternalReferrer = ({
  referrerId = '',
  referrerLink = '',
  referrerName = '',
  referrerType = '',
  referrerURL = '',
} = {}) => ({
  ExternalReferrer: {
    referrerId,
    referrerLink,
    referrerName,
    referrerType,
    referrerURL,
  },
});

export default ExternalReferrer;
